import Form from 'src/utils/Form.js'

class Transfer extends Form {
    constructor(data, config = null, responseType = 'json') {
        super(data, config || Form.config, responseType)
    }

    static all(parameters, then) {
        return new Form().get('transfers' + '?' + parameters).then(then)
    }

    static history(parameters, then) {
        return new Form().get('transfers/history' + '?' + parameters).then(then)
    }

    static references(side, then) {
        return new Form().get(`transfers/references/${side}`).then(then)
    }

    userPayments(then) {
        return super.get(`transfers/${this.reference}/your/payments`).then(then)
    }

    rebitPayments(then) {
        return super.get(`transfers/${this.reference}/our/payments`).then(then)
    }

    refreshStatus(then) {
        return new Form().get(`transfers/${this.reference}/status`).then(then)
    }

    static cmIncomingPayments(then) {
        return new Form().post('/transfers/cm-incoming-payments').then(then)
    }

    static outgoingDetails(reference, then){
        return new Form().get(`transfers/${reference}/outgoing-details`).then(then)
    }

    fetch(then) {
        return super.get(`transfers/${this.reference}`).then(data => {
            this.originalData = data
            for (let field in this.originalData) {
                this[field] = data[field]
            }
            then(data)
        })
    }

    paymentViaPaymentMethod(method, then) {
        return super.post(`transfers/${this.reference}/${method}`).then(then)
    }

    validateTransferAmount(then) {
        return super.post('transfers/validate').then(then)
    }

    make(then) {
        return super.post(`transfers/make`).then((data) => {
            this.originalData = data
            for (let field in this.originalData) {
                this[field] = data[field]
            }
            then(data)
        })
    }

    confirm(parameters, then) {
        return super.post(`transfers/confirm`, parameters).then(then)
    }

    cancel(then) {
        return super.post(`transfers/${this.reference}/cancel`).then(then)
    }

    create(then) {
        return super.post('transfers').then(then)
    }

    review(then) {
        return super.post(`transfers/${this.reference}/review`).then(then)
    }

    edit(then) {
        return super.get(`transfers/${this.reference}/edit`).then(data => {
            this.originalData = data
            for (let field in this.originalData) {
                this[field] = data[field]
            }
            then(data)
        })
    }

    update(then) {
        return super.patch(`transfers/${this.reference}`).then(then)
    }

    updateInline(then) {
        return super.put(`transfers/${this.reference}`).then(then)
    }

    destroy(then) {
        return super.delete(`transfers/${this.reference}`).then(then)
    }

    existReceipts(then) {
        return new Form().get(`transfers/${this.reference}/exist-receipts`).then(then)
    }

    receipts(then) {
        return super.get(`transfers/${this.reference}/receipts/${this.transaction_id}`).then(then)
    }

    downloadReceipt(then) {
        return super.get(`transfers/${this.reference}/receipts/${this.file_name}/download`).then(then)
    }

    sentPaymentReceipts(then) {
        const fd = this.formData(['receipts'])

        return super.post(`transfers/${this.reference}/payment-receipts`, fd).then(then)
    }

    getOnRampInfo(then) {
        return super.get(`transfers/${this.reference}/on-ramp`).then(then)
    }

    getOffRampInfo(then) {
        return super.get(`transfers/${this.reference}/off-ramp`).then(then)
    }

    changeRecipient(then) {
        return super.post(`transfers/${this.reference}/recipient`).then(then)
    }

    updateOrderAndRecipient(then) {
        return super.patch(`transfers/${this.reference}/recipient`).then(then)
    }

    static readyOrdersForWithdrawal(parameters, then) {
        return new Form().get(`transfers/ready-for-withdrawal` + '?' + parameters).then(then)
    }

    cmWithdraw(then) {
        return super.post(`transfers/withdraw/crown-money`).then(then)
    }
}

export default Transfer
